import { types } from 'mobx-state-tree';

export const TicketDetaiForVGSelectionStore = types
    .model('ticketDetaiForVGSelectionStore', {
        id: types.number,
        rate: types.number,
        //number: types.number,
        fixtureName: types.string,
        gameType: types.string,
        betType: types.string,
        result: types.maybeNull(types.string),
        evalState: types.number, //TicketSelectionEvalState
        tipName: types.string,
    })